import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  margin-bottom: 50px;
  font-size: 40px;
`;
